import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'

@observer
class PageDisable extends Component {
    constructor(props) {
        super(props)
    }

    close = () => {
        const { store } = this.props
        store.pageHideConfirm = false
    }

    hidePage = () => {
        const { store } = this.props
        const { survey, pageToHide } = store

        if (pageToHide) {
            const { page } = pageToHide
            page.isHidden = true
            page.update(store, survey)
            store.pageHideConfirm = false
        }
    }

    modalText = () => {
        const { store } = this.props
        const { pageToHide } = store

        let hasSkipLogic = false

        if (pageToHide) {
            const { page } = pageToHide
            const { hasSkipToPage } = page.getSkipToPage(store)
            page.questions.some((pq) => {
                console.log(pq)
                console.log(pq.hasSkipLogic(store))
                return false
            })
            hasSkipLogic = hasSkipToPage
                || page.questions.some((pq) => !!pq.hasSkipLogic(store))
        }
        console.log(hasSkipLogic)
        return i18n.t(`conf_page_disable_${(hasSkipLogic) ? 'skip' : 'no_skip'}`)
    }

    render() {
        const { store } = this.props
        return (

            <Modal
                show={store.pageHideConfirm}
                onClose={this.close}
            >
                <div id="page-disable-modal">
                    <div className="uc-modal__header">
                        <h2>{i18n.t('gen_confirm_popup_title')}</h2>
                        <p className="uc-modal__desc">
                            {this.modalText()}
                        </p>
                    </div>
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={this.hidePage}
                            cssClass="error"
                            label={i18n.t('gen_yes')}
                        />
                        <Button
                            onClick={this.close}
                            cssClass="tertiary"
                            label={i18n.t('gen_no')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

export default PageDisable
